import { FC } from "react"

export const NoDataComponent: FC = () => {
    return(
        <div className="p-10">
            <h2>No hay datos en la tabla</h2>
        </div>
    )
}